export interface PaletteColor {
  key: string
  label: string
  // Tailwind classes for the full-bleed column tint when this drawer is selected
  bg: string          // panel background
  border: string      // panel border
  header: string      // panel header text
  row: string         // selected row bg
  rowText: string     // selected row text
  chip: string        // color chip swatch
  // Tinted variants for child drawers (one level lighter/darker)
  childBg: string
  childRow: string
}

export const PALETTE: PaletteColor[] = [
  {
    key: 'slate',
    label: 'Slate',
    bg: 'bg-slate-50 dark:bg-slate-900/60',
    border: 'border-slate-200 dark:border-slate-700',
    header: 'text-slate-600 dark:text-slate-300',
    row: 'bg-slate-800 dark:bg-slate-200',
    rowText: 'text-white dark:text-slate-900',
    chip: 'bg-slate-500',
    childBg: 'bg-slate-100 dark:bg-slate-800/60',
    childRow: 'bg-slate-700 dark:bg-slate-300',
  },
  {
    key: 'indigo',
    label: 'Indigo',
    bg: 'bg-indigo-50 dark:bg-indigo-950/40',
    border: 'border-indigo-200 dark:border-indigo-800',
    header: 'text-indigo-700 dark:text-indigo-300',
    row: 'bg-indigo-700 dark:bg-indigo-300',
    rowText: 'text-white dark:text-indigo-950',
    chip: 'bg-indigo-500',
    childBg: 'bg-indigo-100 dark:bg-indigo-900/40',
    childRow: 'bg-indigo-600 dark:bg-indigo-400',
  },
  {
    key: 'violet',
    label: 'Violet',
    bg: 'bg-violet-50 dark:bg-violet-950/40',
    border: 'border-violet-200 dark:border-violet-800',
    header: 'text-violet-700 dark:text-violet-300',
    row: 'bg-violet-700 dark:bg-violet-300',
    rowText: 'text-white dark:text-violet-950',
    chip: 'bg-violet-500',
    childBg: 'bg-violet-100 dark:bg-violet-900/40',
    childRow: 'bg-violet-600 dark:bg-violet-400',
  },
  {
    key: 'sky',
    label: 'Sky',
    bg: 'bg-sky-50 dark:bg-sky-950/40',
    border: 'border-sky-200 dark:border-sky-800',
    header: 'text-sky-700 dark:text-sky-300',
    row: 'bg-sky-700 dark:bg-sky-300',
    rowText: 'text-white dark:text-sky-950',
    chip: 'bg-sky-500',
    childBg: 'bg-sky-100 dark:bg-sky-900/40',
    childRow: 'bg-sky-600 dark:bg-sky-400',
  },
  {
    key: 'teal',
    label: 'Teal',
    bg: 'bg-teal-50 dark:bg-teal-950/40',
    border: 'border-teal-200 dark:border-teal-800',
    header: 'text-teal-700 dark:text-teal-300',
    row: 'bg-teal-700 dark:bg-teal-300',
    rowText: 'text-white dark:text-teal-950',
    chip: 'bg-teal-500',
    childBg: 'bg-teal-100 dark:bg-teal-900/40',
    childRow: 'bg-teal-600 dark:bg-teal-400',
  },
  {
    key: 'emerald',
    label: 'Emerald',
    bg: 'bg-emerald-50 dark:bg-emerald-950/40',
    border: 'border-emerald-200 dark:border-emerald-800',
    header: 'text-emerald-700 dark:text-emerald-300',
    row: 'bg-emerald-700 dark:bg-emerald-300',
    rowText: 'text-white dark:text-emerald-950',
    chip: 'bg-emerald-500',
    childBg: 'bg-emerald-100 dark:bg-emerald-900/40',
    childRow: 'bg-emerald-600 dark:bg-emerald-400',
  },
  {
    key: 'amber',
    label: 'Amber',
    bg: 'bg-amber-50 dark:bg-amber-950/40',
    border: 'border-amber-200 dark:border-amber-800',
    header: 'text-amber-700 dark:text-amber-300',
    row: 'bg-amber-600 dark:bg-amber-300',
    rowText: 'text-white dark:text-amber-950',
    chip: 'bg-amber-400',
    childBg: 'bg-amber-100 dark:bg-amber-900/40',
    childRow: 'bg-amber-500 dark:bg-amber-400',
  },
  {
    key: 'rose',
    label: 'Rose',
    bg: 'bg-rose-50 dark:bg-rose-950/40',
    border: 'border-rose-200 dark:border-rose-800',
    header: 'text-rose-700 dark:text-rose-300',
    row: 'bg-rose-700 dark:bg-rose-300',
    rowText: 'text-white dark:text-rose-950',
    chip: 'bg-rose-500',
    childBg: 'bg-rose-100 dark:bg-rose-900/40',
    childRow: 'bg-rose-600 dark:bg-rose-400',
  },
  {
    key: 'pink',
    label: 'Pink',
    bg: 'bg-pink-50 dark:bg-pink-950/40',
    border: 'border-pink-200 dark:border-pink-800',
    header: 'text-pink-700 dark:text-pink-300',
    row: 'bg-pink-700 dark:bg-pink-300',
    rowText: 'text-white dark:text-pink-950',
    chip: 'bg-pink-500',
    childBg: 'bg-pink-100 dark:bg-pink-900/40',
    childRow: 'bg-pink-600 dark:bg-pink-400',
  },
  {
    key: 'orange',
    label: 'Orange',
    bg: 'bg-orange-50 dark:bg-orange-950/40',
    border: 'border-orange-200 dark:border-orange-800',
    header: 'text-orange-700 dark:text-orange-300',
    row: 'bg-orange-600 dark:bg-orange-300',
    rowText: 'text-white dark:text-orange-950',
    chip: 'bg-orange-500',
    childBg: 'bg-orange-100 dark:bg-orange-900/40',
    childRow: 'bg-orange-500 dark:bg-orange-400',
  },
]

export const DEFAULT_COLOR = 'slate'

export function getPalette(key: string): PaletteColor {
  return PALETTE.find(p => p.key === key) ?? PALETTE[0]
}
